import React, { FC, useEffect, useState } from 'react';
import { Snackbar } from '@material-ui/core';
import { Alert, AlertProps } from '@material-ui/lab';

export type ShowAlert = {
  showAlert: boolean;
  severity: AlertProps['severity'];
  message: string;
};

export const alertInitialState: ShowAlert = {
  showAlert: false,
  severity: 'error',
  message: '',
};

const DemoSnackBar: FC<ShowAlert> = (alert) => {
  const [alertProps, setAlertProps] = useState<ShowAlert>(alert);

  useEffect(() => () => setAlertProps(alertInitialState), []);

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={alertProps.showAlert}
        autoHideDuration={2000}
        onClose={() => setAlertProps(alertInitialState)}
      >
        <Alert onClose={() => setAlertProps(alertInitialState)} severity={alertProps.severity}>
          {alertProps.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default DemoSnackBar;
